import { writable } from "svelte/store";

/** @typedef {import('$lib/types/gql').Cart} Cart */

/** @type {?Cart} */
const defatulCart = null;

/** @type {import("svelte/store").Writable<?Cart>} */
export const cart = writable(null)